
// ========= USUARIO ========== //
export const ERROR_API = "ERROR_API"; // error en el api !!
export const SUCCESS_STEP_ONE = "SUCCESS_STEP_ONE"; // request con exito !!
export const SUCCESS_STEP_TWO = "SUCCESS_STEP_TWO"; // request con error

// ========= Messages validation formHome ========= //
export const FIELD_IS_REQUIRED_MESSAGE = "*Campo requerido";
export const LAST_THREE_NUMBER_MESSAGE = "Ultimos 3 digitos deben ser números";
export const CHECK_NUMBER_PLACA_MESSAGE = "Verificar número de placa";
export const EMPTY_PLACA_MESSAGE = "Ingrese una placa válida";
export const USER_YOUNGER_MESSAGE = "Tienes menos de 18 años";
export const USER_ERROR_DATE_MESSAGE = "*Tu fecha de nacimiento es inválido";  
